import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";
const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function AbstractPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Abstract</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Wetlands are productive ecosystems providing an array of services
              that sustain the well-being of dependent biota. Post
              industrialization and globalization era witnessed a spurt in the
              anthropogenic activities leading to the degradation and decline of
              fragile ecosystems. This necessitates the conservation of vital
              ecosystems through sustainable management tenets, which requires
              an understanding of the livelihood support of ecosystems. The
              focus of the current study is to understand the worth of wetlands
              through the accounting of provisioning, regulating, and cultural
              services. The provisional services through accounting of tangible
              benefits (fish, fodder, water, etc.) considering residual values
              indicate an annual revenue of 49.70 billion rupees. Similarly,
              accounting of non-use values of ecosystems through the benefit
              transfer method indicates regulating and cultural services support
              of 196.89; and 37.93 billion rupees/year, respectively. The annual
              flow of total ecosystem supply value accounts for 284.52 billion
              rupees/year and the net present value amounts to 7320.6 billion
              rupees, which signifies the ecological, social-cultural, and
              environmental support wetland provides ecosystems in Karnataka.
              Appraisal of ecosystem services (ES) allows for adjusted national
              accounts which reflect the output of ecosystem services as well as
              the depletion of natural resources and the degradation costs
              (externalized costs of the loss of ecosystem services) of
              ecosystems in economic terms, which will help raise awareness and
              provide a quantitative tool to evaluate the sustainability of
              policies toward prudent management and conservation of fragile
              livelihood supporting ecosystems. The monetary valuation of
              ecosystem services can help in building a better understanding of
              their influence on well-being and can further facilitate
              information-driven decisions and policy reforms that align with
              the Sustainable Development Goals (SDGs) through the wise use of
              natural resources.
            </p>
            <p>
              <strong>
                <em>Keywords:</em>
              </strong>{" "}
              Wetlands, Microalgae, Fish, Macrophyte, SEEA, Ecosystem service,
              Provisioning service, Cultural service, Regulating service, Total
              ecosystem supply value (TESV), Net present value (NPV), Karnataka
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default AbstractPage;
